<div class="language-wrapper">
    <div class="language" [class.selected]="currentLanguage === 'nl'" (click)="onSelectLanguage('nl')">NL</div>
    <div class="language" [class.selected]="currentLanguage === 'fr'" (click)="onSelectLanguage('fr')">FR</div>
</div>
<ng-content></ng-content>